import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon
} from '@material-ui/icons';
import AutoZoom from '../../Map/components/AutoZoom';
import Events from '../../../../../../utilities/EventEmitter';
import { useSelectDriversContext } from '../SelectDriversContext';
import { selectDriversMapConfig } from './config/selectDriversMapConfig';

const styles = (theme: { AppBGColor?: string; headerTextFontSize?: number; HeaderSelectedText?: string; iconColor?: string }) => ({
  headerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${theme.AppBGColor}`,
    marginBottom: 1,
    borderRadius: '4px 4px 0 0',
    padding: '9px 9px',
    fontSize: theme.headerTextFontSize,
    lineHeight: '16px',
    color: theme.HeaderSelectedText,
  },
  label: {
    marginLeft: 6,
  },
  maximizeIcon: {
    cursor: 'pointer',
    color: theme.iconColor,
    padding: 4,
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
});

export interface MapSectionHeaderProps {
  classes?: { headerStyle: string; label: string; maximizeIcon: string; headerActions: string };
}

const MapSectionHeader: React.FC<MapSectionHeaderProps> = ({ classes }) => {
  const { userData, maximizedPanel, setMaximizedPanel, glEventHub } = useSelectDriversContext();
  const [isAutoZoomEnabled, setIsAutoZoomEnabled] = useState(selectDriversMapConfig.autoZoomEnabled);
  const isMaximized = maximizedPanel === 'map';
  const toggleMaximize = () => setMaximizedPanel(isMaximized ? null : 'map');

  useEffect(() => {
    Events.emit('routeAnimationPopup', isAutoZoomEnabled);
    (glEventHub as { emit?: (event: string, value: boolean) => void })?.emit?.('routeAnimation', isAutoZoomEnabled);
  }, []);

  useEffect(() => {
    const handler = (value: boolean) => setIsAutoZoomEnabled(value);
    Events.on('routeAnimationPopup', handler);
    return () => Events.off('routeAnimationPopup', handler);
  }, []);

  const toggleRouteAnimation = (value: boolean) => {
    Events.emit('routeAnimationPopup', value);
    (glEventHub as { emit?: (event: string, value: boolean) => void })?.emit?.('routeAnimation', value);
    setIsAutoZoomEnabled(value);
  };

  return (
    <div className={classes?.headerStyle}>
      <span className={classes?.label}>Map</span>
      <span className={classes?.headerActions}>
        <AutoZoom
          isEnabled={isAutoZoomEnabled}
          toggleRouteAnimation={toggleRouteAnimation}
          userData={userData}
        />
        <span className={classes?.maximizeIcon} onClick={toggleMaximize} title={isMaximized ? 'Minimize' : 'Maximize'} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && toggleMaximize()}>
          {isMaximized ? <FullscreenExitIcon /> : <FullscreenIcon />}
        </span>
      </span>
    </div>
  );
};

export default withStyles(styles)(MapSectionHeader);
